// extracted by mini-css-extract-plugin
export default {"forgot_form":"styles_forgot_form__jHpzX","link":"styles_link__4-0hg"};